import { h, Component, Fragment } from 'preact';
import Router, { getCurrentUrl, route } from 'preact-router';

import './index.less';

import NavBar from '../../pages/NavBar';
import FreeCatalogueBanner from '../../pages/FreeCatalogueBanner';
import AsyncRoute from '../../pages/AsyncRoute';
import RequestIdentityModal from '../../pages/RequestIdentityModal';
import RequestIdentityChat from '../../pages/RequestIdentityChat';
import AddressPicker from '../AddressPicker';
import {
  BUNDLE_VIEW,
  hexToRgba,
  getStoredSearchTerm,
  SEARCH_TERM,
  CHUNK_VIEW,
  RESELLER_TABS,
  redirectToErrorPage,
  logException
} from '../../lib/Utils';
import { getProductInventory } from '../../lib/Inventory';
import { accessCheck, expiryCheck } from '../../lib/Socket';

import {
  onVisitCartNativeHandler,
  awayFromCartNativeHandler
} from '../../../../../nativeConnectors/platform';

import {
  getLastVisitedGroupCatalogueCompanyId,
  getLastVisitedSingleCatalogueCompanyId,
  getRouteParams,
  importGroupBundle,
  importCustomPageBundle,
  importResellerViewBundle,
  importSingleBundle,
  importResellSingleBundle,
  importCompanyDetailBundle,
  importGalleryPageBundle,
  importImagePageBundle,
  importGlobalReviewBundle,
  importCustomerOrdersBundle,
  isGroupRoute,
  isGalleryRoute,
  isLazyComponentFetched,
  isResellerSingleAmalgamRequiredRoute,
  isResellerAmalgamRequiredRoute,
  isResellerViewRoute,
  isReviewRoute,
  isSingleRoute,
  isResellSingleRoute,
  isImageRoute,
  NAME as ROUTE_NAME,
  setCurrentRouteName,
  setLazyComponent,
  setRouteParams,
  isGalleryImageRoute,
  shouldClearFiltersOnRouteChange,
  setLastVisitedHomeOrCatalogueRoute,
  getLastVisitedHomeOrCatalogueRoute,
  getPrevCatalogueRoute,
  isGlobalReviewRoute,
  setPreviousRouteName,
  isCustomerOrdersRoute,
  isCompanyDetailRoute,
  PATH
} from '../../lib/Route';
import {
  initialize as initializeEvents,
  initializeSingle as initializeSingleEvents,
  initializeGroup as initializeGroupEvents,
  onRouteChange
} from '../../lib/Events';
import {
  clearSelectedOrder,
  getFinalizedOrder,
  initialize as initializeOrder
} from '../../lib/Order';
import EventBus from '../../lib/EventBus';
import {
  cancelPreviousProductViewingNowInterval,
  initialize as initializeAnalytics,
  cancel as cancelAnalytics
} from '../../lib/Analytics';
import { resetFilters } from '../../lib/Tags';
import { initialize as initializeBlock, cancel as cancelBlock } from '../../lib/Block';
import { cancelRequestIdentity, initializeRequestIdentity } from '../../lib/Visitor';
import {
  getAmalgam,
  isAmalgamFetched,
  isSearchAmalgamFetched,
  mergeProductsIntoDefaultVariants,
  mergeProductsIntoNonDefaultVariants,
  validateEndpoint,
  showCreateFreeCatalogueBanner,
  onBannerClose,
  mergeNewVariantWithAmalgam,
  getProduct,
  getUpdatedAmalgamPromises,
  getAmalgamSavedSearchResults,
  isCustomPage,
  getCompanyId,
  getVisitorId,
  getCatalogue,
  getGlobalReviewAmalgam
} from '../../lib/Amalgam';
import {
  getGroupAmalgam,
  isGroupAmalgamFetched,
  getPaymentStatus as getGroupPaymentStatus,
  getCustomPageGroupAmalgam,
  getCachedCustomPageAmalgam
} from '../../lib/GroupAmalgam';
import { shouldShowMandatoryLogin } from '../../lib/Experiments';
// import ChatNowPopover from '../../organisms/ChatNowPopover'
import { resetEndpointProductIdMapCache, clearCache } from '../../lib/ProductCache';
import OrderAlreadyConfirmed from '../../molecules/OrderAlreadyConfirmed';
import { doTagsExist } from '../../lib/Catalogue';
import { createManifestUrl } from '../../lib/Manifest';
import {
  getResellerViewAmalgam,
  isResellerViewAmalgamFetched,
  getPaymentStatus as getResellerPaymentStatus,
  getResellerRoute
} from '../../lib/ResellerViewAmalgam';
import { getCatalogueTheme } from '../../lib/Theme';
import SpecialOfferModal from '../SpecialOfferModal';
import { getShowcaseId } from '../../lib/GroupCatalogueAmalgam';
import {
  getCustomPageAmalgamObject,
  setCustomPageAmalgamObject
} from '../../lib/CustomPageAmalgam';
import DeleteAccountConfirmationModal from '../DeleteAccountConfirmationModal';
import {
  clearCachedScrollPositions,
  getCachedScrollPositionForPage,
  setCachedScrollPositionForPage,
  shouldCacheScrollPositionForRoute
} from '../../lib/ScrollPosition';
import { setOpenDtModal, setShowDtChat } from '../../lib/Chat';

let mandatoryLoginDone = false;

class App extends Component {
  constructor (props) {
    super(props);

    const { companySlug, catalogueSlug, randomSlug, companyDetailSlug } = getRouteParams();
    const amalgamFetched = isAmalgamFetched({
      companySlug,
      catalogueSlug,
      randomSlug,
      companyDetailSlug
    });

    this.state = {
      amalgamFetched,
      lazyComponentFetched: isLazyComponentFetched(CHUNK_VIEW.SINGLE_CATALOGUE),
      galleryLazyComponentFetched: isLazyComponentFetched(CHUNK_VIEW.GALLERY_PAGE),
      imageLazyComponentFetched: isLazyComponentFetched(CHUNK_VIEW.IMAGE_PAGE),
      resellSingleLazyComponentFetched: isLazyComponentFetched(CHUNK_VIEW.RESELL_SINGLE_CATALOGUE),
      groupAmalgamFetched: isGroupAmalgamFetched(),
      globalReviewAmalgamFetched: amalgamFetched,
      globalReviewLazyComponentFetched: isLazyComponentFetched(CHUNK_VIEW.GLOBAL_REVIEW),
      groupLazyComponentFetched: isLazyComponentFetched(
        isCustomPage() ? CHUNK_VIEW.CUSTOM_PAGE : CHUNK_VIEW.GROUP_CATALOGUE
      ),
      resellerViewAmalgamFetched: isResellerViewAmalgamFetched(),
      resellerViewLazyComponentFetched: isLazyComponentFetched(CHUNK_VIEW.RESELLER),
      companyDetailLazyComponentFetched: isLazyComponentFetched(CHUNK_VIEW.COMPANY_DETAIL),
      customerOrdersLazyComponentFetched: isLazyComponentFetched(CHUNK_VIEW.CUSTOMER_ORDERS),
      companyDetailAmalgamFetched: amalgamFetched,
      customerOrdersAmalgamFetched: amalgamFetched,
      prevRoutePath: null,
      prevRoute: null,
      currentRoute: null,
      productId: null,
      groupRoutePath: null,
      resellerRoutePath: null,
      resellerTabIndex: null,
      mandatoryLoginDone: !!mandatoryLoginDone,
      customPageScrollYPosition: 0
    };

    this.initialListMarginTop = null;
    this.doCatalogueTagsExist = false;
    this.prevStateExists = false;
    this.currentCatalogueSlug = null;
    this.entryUrl = null;
    this.homeToHomePageNavigation = false;
  }

  componentDidMount () {
    initializeEvents();
    createManifestUrl();

    accessCheck(getVisitorId(), getCompanyId(), getCatalogue());
    expiryCheck();

    EventBus.addListener(EventBus.TYPE.CLEAR_AMALGAM, this.onClearAmalgam);
    EventBus.addListener(EventBus.TYPE.MANDATORY_LOGIN_DONE, this.onMandatoryLoginDone);
    window.addEventListener('beforeunload', this.onCloseTab);
  }

  componentWillUnmount () {
    EventBus.removeListener(EventBus.TYPE.CLEAR_AMALGAM, this.onClearAmalgam);
    EventBus.removeListener(EventBus.TYPE.MANDATORY_LOGIN_DONE, this.onMandatoryLoginDone);
    window.removeEventListener('beforeunload', this.onCloseTab);
  }

  onCloseTab = () => clearCachedScrollPositions();

  onClearAmalgam = () => {
    const { companySlug, catalogueSlug, randomSlug, companyDetailSlug } = getRouteParams();

    this.setState({
      amalgamFetched: isAmalgamFetched({
        companySlug,
        catalogueSlug,
        randomSlug,
        companyDetailSlug
      })
    });
  };

  getTitleBar = () => {
    if (!this.titleBar) {
      this.titleBar = document.querySelector('.nav-bar');
    }

    return this.titleBar;
  };

  getList = () => {
    if (!this.listElement) {
      this.listElement = document.querySelector('.home-container > div > div');
    }

    return this.listElement;
  };

  resetTitleBar = () => {
    if (!this.doCatalogueTagsExist) {
      return;
    }

    const titleBar = this.getTitleBar();
    const list = this.getList();

    if (!titleBar || !list) {
      return;
    }

    titleBar.style.top = '0px';
    list.style.marginTop = `${this.initialListMarginTop}px`;
  };

  onMandatoryLoginDone = () => {
    mandatoryLoginDone = true;
    this.setState({ mandatoryLoginDone: true }, () => {
      if (this.state.amalgamFetched) {
        this.doCatalogueTagsExist = doTagsExist();
        initializeSingleEvents();
        initializeRequestIdentity();
        initializeBlock();
        initializeOrder();
        initializeAnalytics();
      }
    });
  };

  shouldShowMandatoryLogin = () => {
    const { amalgamFetched, mandatoryLoginDone } = this.state;

    if (!amalgamFetched) {
      return false;
    }

    return !mandatoryLoginDone && shouldShowMandatoryLogin();
  };

  getComponentFetchStateKeyAsPerView ({ view = CHUNK_VIEW.SINGLE_CATALOGUE }) {
    if (view === CHUNK_VIEW.RESELLER) {
      return 'resellerViewLazyComponentFetched';
    } else if (view === CHUNK_VIEW.GALLERY_PAGE) {
      return 'galleryLazyComponentFetched';
    } else if (view === CHUNK_VIEW.IMAGE_PAGE) {
      return 'imageLazyComponentFetched';
    } else if (view === CHUNK_VIEW.RESELL_SINGLE_CATALOGUE) {
      return 'resellSingleLazyComponentFetched';
    } else if (view === CHUNK_VIEW.GLOBAL_REVIEW) {
      return 'globalReviewLazyComponentFetched';
    }

    return 'lazyComponentFetched';
  }

  onSingleAmalgamFetched = ({ view = CHUNK_VIEW.SINGLE_CATALOGUE, productId } = {}) => {
    resetEndpointProductIdMapCache();
    clearCache();
    const isRedirecting = validateEndpoint({ productId, replace: true });

    if (isRedirecting === true) {
      return;
    }

    const product = getProduct(productId);
    if (product && product.parentProductId) {
      mergeNewVariantWithAmalgam({
        product,
        inventory: getProductInventory(productId)
      });
    }

    mergeProductsIntoDefaultVariants({ productIds: [productId] });
    mergeProductsIntoNonDefaultVariants();

    this.setState(
      {
        amalgamFetched: true,
        [this.getComponentFetchStateKeyAsPerView({ view })]: true,
        showBanner: showCreateFreeCatalogueBanner()
      },
      () => {
        if (!this.shouldShowMandatoryLogin()) {
          this.doCatalogueTagsExist = doTagsExist();
          initializeSingleEvents();
          initializeRequestIdentity();
          initializeBlock();
          initializeOrder();
          initializeAnalytics();
        }
      }
    );
  };

  onGroupAmalgamFetched = () => {
    setShowDtChat(false);
    if (isCustomPage()) {
      const { customPageSlug } = getRouteParams();
      const customPageAmalgam = getCustomPageAmalgamObject() || {};
      const customPageCachedAmalgam = getCachedCustomPageAmalgam(customPageSlug) || {};
      // Note: if user presses back button then it's possible that the previous custom page cached amalgam will still be used in the custom page component
      // If that happens then wrong sections might be displayed on the current custom page slug, so it's better to update the cache here to be on safe side
      if (
        customPageAmalgam.customPage &&
        customPageCachedAmalgam.customPage &&
        customPageAmalgam.customPage.id !== customPageCachedAmalgam.customPage.id
      ) {
        setCustomPageAmalgamObject(customPageCachedAmalgam);
      }
    }
    this.setState({ groupAmalgamFetched: true, groupLazyComponentFetched: true });
    initializeGroupEvents({ paymentStatus: getGroupPaymentStatus() });
  };

  onResellerViewFetched = () => {
    setShowDtChat(false);
    this.setState({ resellerViewLazyComponentFetched: true });
  };

  onResellerViewAmalgamFetched = () => {
    this.onResellerViewFetched();
    this.setState({ resellerViewAmalgamFetched: true });
    initializeGroupEvents({ paymentStatus: getResellerPaymentStatus() });
  };

  onSingleMount = ({ productId, view = CHUNK_VIEW.SINGLE_CATALOGUE }) => {
    const { companySlug, catalogueSlug, randomSlug, companyDetailSlug } = getRouteParams();

    if (!companyDetailSlug) {
      const slug = `${companySlug}/${catalogueSlug}/${randomSlug}`;
      if (this.currentCatalogueSlug !== slug) {
        resetFilters();
      }
      this.currentCatalogueSlug = slug;
    }

    const amalgamFetched = isAmalgamFetched({
      companySlug,
      catalogueSlug,
      randomSlug,
      companyDetailSlug
    });

    const lazyComponentFetched = isLazyComponentFetched(view);

    if (amalgamFetched && lazyComponentFetched) {
      this.onSingleAmalgamFetched({ view, productId });
      return;
    }

    if (!amalgamFetched) {
      this.setState({ amalgamFetched: false });
    }

    if (!lazyComponentFetched) {
      this.setState({ [this.getComponentFetchStateKeyAsPerView({ view })]: false });
    }

    const globalSearchTerm = getStoredSearchTerm();
    const searchedProductUpdatedAmalgam = getAmalgamSavedSearchResults()[productId];

    let componentFetchPromise = importSingleBundle;
    let fromBundle;
    if (view === CHUNK_VIEW.RESELLER) {
      fromBundle = BUNDLE_VIEW.RESELLER;
      componentFetchPromise = importResellerViewBundle;
    } else if (view === CHUNK_VIEW.GALLERY_PAGE) {
      componentFetchPromise = importGalleryPageBundle;
    } else if (view === CHUNK_VIEW.IMAGE_PAGE) {
      componentFetchPromise = importImagePageBundle;
    } else if (view === CHUNK_VIEW.RESELL_SINGLE_CATALOGUE) {
      componentFetchPromise = importResellSingleBundle;
    }

    Promise.all([
      amalgamFetched || (globalSearchTerm && searchedProductUpdatedAmalgam)
        ? Promise.resolve()
        : globalSearchTerm
          ? getUpdatedAmalgamPromises(productId)
          : getAmalgam({
            companySlug,
            catalogueSlug,
            randomSlug,
            companyDetailSlug,
            productId,
            fromBundle
          }),
      lazyComponentFetched ? Promise.resolve() : componentFetchPromise()
    ])
      .then(([response, module]) => {
        if (!lazyComponentFetched) {
          setLazyComponent(view, module.default);
        }

        if (!amalgamFetched && !globalSearchTerm) {
          if (response.reloadPage) {
            window.location.reload();
          }
        }

        this.onSingleAmalgamFetched({ view, productId });
      })
      .catch((error) => {
        logException('Redirecting to error page, onSingleMount Failed', { error });
        redirectToErrorPage();
      });
  };

  onSingleUnmount = () => {
    cancelRequestIdentity();
    cancelBlock();
    cancelAnalytics().then();
  };

  onReviewMount = ({ orderId }) => {
    const amalgamFetched = isAmalgamFetched();
    const lazyComponentFetched = isLazyComponentFetched(CHUNK_VIEW.GLOBAL_REVIEW);

    if (amalgamFetched && lazyComponentFetched) {
      setShowDtChat(false);
      this.setState({ globalReviewAmalgamFetched: true, globalReviewLazyComponentFetched: true });
      return;
    }

    if (!amalgamFetched) {
      this.setState({ globalReviewAmalgamFetched: false });
    }

    if (!lazyComponentFetched) {
      this.setState({ globalReviewLazyComponentFetched: false });
    }

    Promise.all([
      amalgamFetched ? Promise.resolve() : getGlobalReviewAmalgam({ orderId }),
      lazyComponentFetched ? Promise.resolve() : importGlobalReviewBundle()
    ])
      .then(([, module]) => {
        if (!lazyComponentFetched) {
          setLazyComponent(CHUNK_VIEW.GLOBAL_REVIEW, module.default);
        }

        setShowDtChat(false);
        this.setState({ globalReviewAmalgamFetched: true, globalReviewLazyComponentFetched: true });
      })
      .catch((error) => {
        logException('Redirecting to error page, onGlobalReviewMount Failed', { error });
        redirectToErrorPage();
      });
  };

  onGroupMount = () => {
    const amalgamFetched = isGroupAmalgamFetched();
    const lazyComponentFetched = isLazyComponentFetched(
      isCustomPage() ? CHUNK_VIEW.CUSTOM_PAGE : CHUNK_VIEW.GROUP_CATALOGUE
    );

    if (amalgamFetched && lazyComponentFetched) {
      this.onGroupAmalgamFetched();
      return;
    }

    if (!amalgamFetched) {
      this.setState({ groupAmalgamFetched: false });
    }

    if (!lazyComponentFetched) {
      this.setState({ groupLazyComponentFetched: false });
    }

    Promise.all([
      amalgamFetched
        ? Promise.resolve()
        : isCustomPage()
          ? getCustomPageGroupAmalgam()
          : getGroupAmalgam(),
      lazyComponentFetched
        ? Promise.resolve()
        : isCustomPage()
          ? importCustomPageBundle()
          : importGroupBundle()
    ])
      .then(([, module]) => {
        if (!lazyComponentFetched) {
          setLazyComponent(
            isCustomPage() ? CHUNK_VIEW.CUSTOM_PAGE : CHUNK_VIEW.GROUP_CATALOGUE,
            module.default
          );
        }

        this.onGroupAmalgamFetched();
      })
      .catch((error) => {
        logException('Redirecting to error page, onGroupMount Failed', { error });
        redirectToErrorPage();
      });
  };

  onGroupUnmount = () => {};

  onCustomerOrdersMount = () => {
    const amalgamFetched = isAmalgamFetched();

    const lazyComponentFetched = isLazyComponentFetched(CHUNK_VIEW.CUSTOMER_ORDERS);

    if (amalgamFetched && lazyComponentFetched) {
      setShowDtChat(false);
      this.setState({
        customerOrdersAmalgamFetched: true,
        customerOrdersLazyComponentFetched: true
      });
      return;
    }

    if (!amalgamFetched) {
      this.setState({ customerOrdersAmalgamFetched: false });
    }

    if (!lazyComponentFetched) {
      this.setState({
        customerOrdersLazyComponentFetched: false
      });
    }

    Promise.all([
      amalgamFetched ? Promise.resolve() : getAmalgam({ companyDetailSlug: 'privacy-policy' }),
      lazyComponentFetched ? Promise.resolve() : importCustomerOrdersBundle()
    ])
      .then(([, module]) => {
        if (!lazyComponentFetched) {
          setLazyComponent(CHUNK_VIEW.CUSTOMER_ORDERS, module.default);
        }

        setShowDtChat(false);
        this.setState({
          customerOrdersAmalgamFetched: true,
          customerOrdersLazyComponentFetched: true
        });
      })
      .catch((error) => {
        logException('Redirecting to error page, onCustomerOrdersMount Failed', { error });
        redirectToErrorPage();
      });
  };

  onCompanyDetailMount = () => {
    const { companyDetailSlug } = getRouteParams();

    const amalgamFetched = isAmalgamFetched({ companyDetailSlug });

    const lazyComponentFetched = isLazyComponentFetched(CHUNK_VIEW.COMPANY_DETAIL);

    if (amalgamFetched && lazyComponentFetched) {
      setShowDtChat(false);
      this.setState({
        companyDetailAmalgamFetched: true,
        companyDetailLazyComponentFetched: true
      });
      return;
    }

    if (!amalgamFetched) {
      this.setState({ companyDetailAmalgamFetched: false });
    }

    if (!lazyComponentFetched) {
      this.setState({
        companyDetailLazyComponentFetched: false
      });
    }

    Promise.all([
      amalgamFetched ? Promise.resolve() : getAmalgam({ companyDetailSlug }),
      lazyComponentFetched ? Promise.resolve() : importCompanyDetailBundle()
    ])
      .then(([, module]) => {
        if (!lazyComponentFetched) {
          setLazyComponent(CHUNK_VIEW.COMPANY_DETAIL, module.default);
        }

        setShowDtChat(false);
        this.setState({
          companyDetailAmalgamFetched: true,
          companyDetailLazyComponentFetched: true
        });
      })
      .catch((error) => {
        logException('Redirecting to error page, onCompanyDetailMount Failed', { error });
        redirectToErrorPage();
      });
  };

  onCompanyDetailUnmount = () => {};

  onResellerAmalgamViewMount = ({ tabIndex, orderId, companySlug, randomSlug }) => {
    const amalgamFetched = isResellerViewAmalgamFetched();
    const lazyComponentFetched = isLazyComponentFetched(CHUNK_VIEW.RESELLER);

    if (amalgamFetched && lazyComponentFetched) {
      this.onResellerViewAmalgamFetched();
      return;
    }

    if (!amalgamFetched) {
      this.setState({ resellerViewAmalgamFetched: false });
    }

    if (!lazyComponentFetched) {
      this.setState({ resellerViewLazyComponentFetched: false });
    }

    Promise.all([
      amalgamFetched
        ? Promise.resolve()
        : getResellerViewAmalgam({ tabIndex, orderId, companySlug, randomSlug }),
      lazyComponentFetched ? Promise.resolve() : importResellerViewBundle()
    ])
      .then(([, module]) => {
        if (!lazyComponentFetched) {
          setLazyComponent(CHUNK_VIEW.RESELLER, module.default);
        }

        this.onResellerViewAmalgamFetched();
      })
      .catch(() => {});
  };

  onResellerAmalgamViewUnmount = () => {};

  onResellerViewMount = () => {
    const lazyComponentFetched = isLazyComponentFetched(CHUNK_VIEW.RESELLER);

    if (lazyComponentFetched) {
      this.onResellerViewFetched();
      return;
    }

    if (!lazyComponentFetched) {
      this.setState({ resellerViewLazyComponentFetched: false });
    }

    Promise.all([lazyComponentFetched ? Promise.resolve() : importResellerViewBundle()])
      .then(([module]) => {
        if (!lazyComponentFetched) {
          setLazyComponent(CHUNK_VIEW.RESELLER, module.default);
        }

        this.onResellerViewFetched();
      })
      .catch(() => {});
  };

  routeBelongsToSameCatalogue = ({
    previous: prevRoutePath,
    current: { catalogueSlug, companySlug, randomSlug }
  } = {}) => {
    if (!prevRoutePath) {
      return true;
    }

    const [, , prevCompanySlug, prevCatalogueSlug, prevRandomSlug] = prevRoutePath.split('/');

    return (
      prevCatalogueSlug === catalogueSlug &&
      prevCompanySlug === companySlug &&
      prevRandomSlug === randomSlug
    );
  };

  handleScrollPosition = () => {
    const { prevRoutePath } = this.state;
    const { scrollLeft, scrollTop } = getCachedScrollPositionForPage(prevRoutePath, true) || {};
    if (typeof scrollLeft === 'number' || typeof scrollTop === 'number') {
      setTimeout(() => window.scrollTo(scrollLeft || 0, scrollTop || 0), 100);
    }
  };

  onRouteChange = (e) => {
    const previousRoute = this.state.currentRoute;
    const currentRoute = e.current.props.name;
    this.homeToHomePageNavigation = false;
    this.prevStateExists = !!e.previous;

    if (!this.prevStateExists) {
      this.entryUrl = e.current.props.url;
    }

    const { pathname, search } = window.location;
    if (this.state.prevRoutePath === (pathname + search || '')) {
      this.handleScrollPosition();
    }
    if (
      shouldCacheScrollPositionForRoute({
        previousRoute,
        currentRoute
      })
    ) {
      setCachedScrollPositionForPage({
        scrollTop: window.scrollY,
        pathname: e.previous
      });
      window.scrollTo(0, 0);
    }

    if (
      (currentRoute === ROUTE_NAME.HOME && previousRoute === ROUTE_NAME.HOME) ||
      (currentRoute === ROUTE_NAME.RESELLER_CATALOGUE_HOME &&
        previousRoute === ROUTE_NAME.RESELLER_CATALOGUE_HOME)
    ) {
      this.homeToHomePageNavigation = true;
    }
    if (isGlobalReviewRoute(currentRoute) && !isGlobalReviewRoute(previousRoute)) {
      onVisitCartNativeHandler(location.href);
    }

    if (isGlobalReviewRoute(previousRoute) && !isGlobalReviewRoute(currentRoute)) {
      awayFromCartNativeHandler(location.href);
    }

    const wasSingle = isSingleRoute(previousRoute);
    const isSingle = isSingleRoute(currentRoute);
    const wasResellSingle = isResellSingleRoute(previousRoute);
    const isResellSingle = isResellSingleRoute(currentRoute);
    const wasGallery = isGalleryRoute(previousRoute);
    const isGallery = isGalleryRoute(currentRoute);
    const wasImage = isImageRoute(previousRoute);
    const isImage = isImageRoute(currentRoute);
    const wasCompanyDetail = isCompanyDetailRoute(previousRoute);
    const isCompanyDetail = isCompanyDetailRoute(currentRoute);
    const wasGroup = isGroupRoute(previousRoute);
    const isGroup = isGroupRoute(currentRoute);
    const wasReview = isReviewRoute(previousRoute);
    const isReview = isReviewRoute(currentRoute);
    const wasOrdersRoute = isCustomerOrdersRoute(previousRoute);
    const isOrdersRoute = isCustomerOrdersRoute(currentRoute);
    const wasResellerAmalgam = isResellerAmalgamRequiredRoute(previousRoute);
    const isResellerAmalgam = isResellerAmalgamRequiredRoute(currentRoute);
    const wasResellerSingleAmalgam = isResellerSingleAmalgamRequiredRoute(previousRoute);
    const isResellerSingleAmalgam = isResellerSingleAmalgamRequiredRoute(currentRoute);
    const isReseller = isResellerViewRoute(currentRoute);

    if (isReseller) {
      setShowDtChat(false);
    } else {
      this.resetTitleBar();
    }

    if (previousRoute !== currentRoute) {
      setOpenDtModal(false);
    }

    const companySlug = e.current.props.companySlug;
    const catalogueSlug = e.current.props.catalogueSlug;
    const randomSlug = e.current.props.randomSlug;
    const customPageSlug =
      !!e.current.props.customPageSlug || e.current.props.customPageSlug === ''
        ? e.current.props.customPageSlug
        : isCustomPage() && !catalogueSlug && !randomSlug
          ? location.pathname.replace('/', '')
          : undefined;
    const companyDetailSlug = e.current.props.companyDetailSlug;
    const orderId = e.current.props.orderId;

    setRouteParams({
      companySlug,
      catalogueSlug,
      randomSlug,
      customPageSlug,
      companyDetailSlug
    });

    setCurrentRouteName(currentRoute);
    setPreviousRouteName(previousRoute);

    if (isGlobalReviewRoute(currentRoute) && !isGlobalReviewRoute(previousRoute)) {
      setLastVisitedHomeOrCatalogueRoute({
        route: getPrevCatalogueRoute({ route: e.previous, currentRoute, previousRoute }),
        wasGroupRoute: wasGroup,
        wasSingleRoute: wasSingle
      });
    }

    if (
      (!wasSingle && isSingle) ||
      (isSingle && wasSingle) ||
      (!wasGallery && isGallery) ||
      (isGallery && wasGallery) ||
      (!wasImage && isImage) ||
      (wasImage && isImage) ||
      (!wasResellSingle && isResellSingle)
    ) {
      const productId = isGalleryImageRoute(e.current.props.name)
        ? e.current.props.productId
        : null;
      this.onSingleMount({
        productId,
        view: isGallery
          ? CHUNK_VIEW.GALLERY_PAGE
          : isImage
            ? CHUNK_VIEW.IMAGE_PAGE
            : isResellSingle
              ? CHUNK_VIEW.RESELL_SINGLE_CATALOGUE
              : CHUNK_VIEW.SINGLE_CATALOGUE,
        currentRoute
      });
    }

    if ((wasSingle || wasReview || wasGallery) && !isSingle && !isReview && !isGallery) {
      this.onSingleUnmount();
    }

    if ((!wasReview && isReview) || (wasReview && isReview)) {
      this.onReviewMount({ orderId });
    }

    if ((!wasGroup && isGroup) || (wasGroup && isGroup)) {
      this.onGroupMount();
      if (isCustomPage() && this.state.customPageScrollYPosition > 0) {
        window.scroll(0, this.state.customPageScrollYPosition);
      }
    }

    if ((!wasCompanyDetail && isCompanyDetail) || (isCompanyDetail && wasCompanyDetail)) {
      this.onCompanyDetailMount();
    }

    if ((!wasOrdersRoute && isOrdersRoute) || (isOrdersRoute && wasOrdersRoute)) {
      this.onCustomerOrdersMount();
    }

    if (wasGroup && !isGroup) {
      this.onGroupUnmount();
      if (isCustomPage() && window.scrollY > 0) {
        this.setState({ customPageScrollYPosition: window.scrollY });
      }
    }

    if (wasGroup && isSingle) {
      resetFilters();
    }

    if (wasResellerSingleAmalgam) {
      if (!isResellerSingleAmalgam) {
        this.onSingleUnmount();
      }
    } else if (isResellerSingleAmalgam) {
      const productId = isGalleryImageRoute(currentRoute) ? e.current.props.productId : null;
      this.onSingleMount({ productId, view: CHUNK_VIEW.RESELLER, currentRoute });
    }

    if (wasResellerAmalgam) {
      if (!isResellerAmalgam) {
        this.onResellerAmalgamViewUnmount();
      }
    } else if (isResellerAmalgam) {
      this.onResellerAmalgamViewMount({
        tabIndex: e.current.props.tabIndex,
        orderId: e.current.props.orderId,
        companySlug: e.current.props.companySlug,
        randomSlug: e.current.props.randomSlug
      });
    }

    if (isReseller && !isResellerAmalgam && !isResellerSingleAmalgam) {
      this.onResellerViewMount();
    }

    const groupAmalgamFetched = this.isGroupAmalgamFetched();
    let amalgamFetched = this.isAmalgamFetched();

    if (wasSingle && isSingle) {
      if (currentRoute === ROUTE_NAME.HOME && previousRoute === ROUTE_NAME.HOME) {
        if (
          !this.routeBelongsToSameCatalogue({
            previous: e.previous,
            current: e.current.props
          })
        ) {
          EventBus.notify(EventBus.TYPE.CLEAR_FILTER_ON_CATALOGUE_UNMOUNT);
        }
        if (amalgamFetched) {
          // unmounts home single hoc and mount it back after a delay
          amalgamFetched = false;
          setTimeout(() => {
            this.setState({ amalgamFetched: true });
          }, 50);
        }
      }

      if (previousRoute === ROUTE_NAME.HOME && currentRoute === ROUTE_NAME.GALLERY) {
        const galleryCatalogueAmalgam = isAmalgamFetched(e.current.props);
        if (
          !this.routeBelongsToSameCatalogue({
            previous: e.previous,
            current: e.current.props
          })
        ) {
          EventBus.notify(EventBus.TYPE.CLEAR_FILTER_ON_CATALOGUE_UNMOUNT);
        }
        if (!galleryCatalogueAmalgam) {
          amalgamFetched = false;
        }
      }

      const productId = isGalleryImageRoute(currentRoute) ? e.current.props.productId : null;

      this.onSingleMount({ productId, currentRoute });
    }

    if (this.prevStateExists && isCustomerOrdersRoute(currentRoute)) {
      // common amalgam will be available and loads the orders via api
      amalgamFetched = true;
    }

    this.setState(
      {
        groupAmalgamFetched,
        amalgamFetched,
        prevRoutePath: e.previous,
        prevRoute: previousRoute,
        currentRoute,
        groupRoutePath:
          this.state.groupRoutePath ||
          (previousRoute === ROUTE_NAME.GROUP || previousRoute === ROUTE_NAME.CUSTOM_PAGE
            ? e.previous
            : null),
        resellerRoutePath: isResellerViewRoute(currentRoute) && getShowcaseId(),
        resellerTabIndex: e.current.props.tabIndex ? parseInt(e.current.props.tabIndex, 10) : null,
        productId: isGalleryImageRoute(e.current.props.name) ? e.current.props.productId : null
      },
      () => {
        onRouteChange({ callNativeHandler: isResellerViewRoute(currentRoute) });
      }
    );

    if (!isGalleryImageRoute(e.current.props.name)) {
      cancelPreviousProductViewingNowInterval('finished');
    }

    EventBus.notify(EventBus.TYPE.ROUTE_CHANGE);
  };

  goBack = () => {
    const { groupRoutePath, resellerRoutePath, prevRoute, currentRoute, resellerTabIndex } =
      this.state;

    this.handleScrollPosition();

    const { companySlug, catalogueSlug, randomSlug } = getRouteParams();
    if (shouldClearFiltersOnRouteChange(currentRoute)) {
      EventBus.notify(EventBus.TYPE.CLEAR_FILTER_ON_CATALOGUE_UNMOUNT);
    }
    if (currentRoute === ROUTE_NAME.HOME && prevRoute === ROUTE_NAME.HOME) {
      this.prevStateExists = false;
      window.history.back();
      return;
    }

    if (currentRoute === ROUTE_NAME.COMPANY_DETAIL) {
      window.history.back();
      this.prevStateExists = false;
      return;
    }

    if (currentRoute === ROUTE_NAME.GALLERY && prevRoute === ROUTE_NAME.GALLERY) {
      // Note: this condition is to handle route switched between 2 products by clicking on one of the more product tiles in <MoreProducts /> component
      window.history.back();
      this.prevStateExists = false;
      return;
    }

    if (currentRoute === ROUTE_NAME.GALLERY && !prevRoute) {
      // Note: this condition is to handle the case when gallery page is directly loaded for the first time and back icon should redirect to s link page
      route(`/s/${companySlug}/${catalogueSlug}/${randomSlug}`);
      window.scroll(0, 0);
      return;
    }

    if (currentRoute === ROUTE_NAME.GALLERY && prevRoute === ROUTE_NAME.CUSTOM_PAGE) {
      // Note: this condition is to handle route switched between custom page and product link in one of the banner images in banner section
      window.history.back();
      this.prevStateExists = false;
      return;
    }

    if (currentRoute === ROUTE_NAME.HOME && groupRoutePath) {
      if (
        prevRoute === ROUTE_NAME.GROUP ||
        prevRoute === ROUTE_NAME.CUSTOM_PAGE ||
        prevRoute === ROUTE_NAME.GALLERY
      ) {
        window.history.back();
        this.prevStateExists = false;
      } else {
        route(groupRoutePath, true);
      }
      return;
    }

    if (currentRoute === ROUTE_NAME.RESELLER_CATALOGUE_HOME && resellerRoutePath) {
      if (prevRoute === ROUTE_NAME.RESELLER_VIEW && resellerTabIndex === RESELLER_TABS.CATALOGUE) {
        window.history.back();
        this.prevStateExists = false;
      } else {
        route(getResellerRoute(RESELLER_TABS.CATALOGUE));
      }
      return;
    }

    if (
      currentRoute === ROUTE_NAME.GALLERY &&
      prevRoute !== ROUTE_NAME.HOME &&
      companySlug &&
      catalogueSlug &&
      randomSlug
    ) {
      window.history.back();
      this.prevStateExists = false;
      return;
    }

    // Handles the case when the product is clicked
    if (
      currentRoute === ROUTE_NAME.RESELLER_CATALOGUE_GALLERY &&
      prevRoute !== ROUTE_NAME.RESELLER_CATALOGUE_HOME &&
      companySlug &&
      catalogueSlug &&
      randomSlug
    ) {
      route(
        `/t/${companySlug}/${catalogueSlug}/${randomSlug}?tabIndex=${RESELLER_TABS.CATALOGUE}`,
        true
      );
      return;
    }

    if (isGlobalReviewRoute(currentRoute)) {
      const finalizedOrder = getFinalizedOrder();
      const { paymentTransactionId, companyId, paymentMode } = finalizedOrder || {};
      const lastSingleCompanyId = getLastVisitedSingleCatalogueCompanyId();
      const lastGroupCompanyId = getLastVisitedGroupCatalogueCompanyId();
      const {
        route: lastVisitedRoute,
        wasGroupRoute,
        wasSingleRoute
      } = getLastVisitedHomeOrCatalogueRoute();

      const isSameCompanyId = () => {
        if (wasGroupRoute === 'true') {
          return lastGroupCompanyId === companyId;
        }
        if (wasSingleRoute === 'true') {
          return lastSingleCompanyId === companyId;
        }
        return false;
      };

      if (
        lastVisitedRoute &&
        isSameCompanyId() &&
        (paymentTransactionId || paymentMode === 'CASH_ON_DELIVERY')
      ) {
        // clearing session storage
        setLastVisitedHomeOrCatalogueRoute();

        // if order is finalized, clear it from cache key
        if (finalizedOrder) {
          clearSelectedOrder();
          route(lastVisitedRoute);
          return;
        }
      }
    }

    if (
      this.prevStateExists &&
      'history' in window &&
      (currentRoute !== ROUTE_NAME.GALLERY || prevRoute !== ROUTE_NAME.GLOBAL_REVIEW)
    ) {
      window.history.back();
      this.prevStateExists = false;
      return;
    }

    if (!this.prevStateExists && isGlobalReviewRoute(currentRoute)) {
      route('/');
      return;
    }

    if (!companySlug || !catalogueSlug || !randomSlug) {
      window.history.back();
      this.prevStateExists = false;
      return;
    }

    route(`/s/${companySlug}/${catalogueSlug}/${randomSlug}`, true);
  };

  isAmalgamFetched = () => {
    if (getStoredSearchTerm()) {
      return isSearchAmalgamFetched();
    }

    const { companySlug, catalogueSlug, randomSlug, companyDetailSlug } = getRouteParams();

    return isAmalgamFetched({
      companySlug,
      catalogueSlug,
      randomSlug,
      companyDetailSlug
    });
  };

  isGroupAmalgamFetched = () => isGroupAmalgamFetched();

  isResellerViewAmalgamFetched = () => isResellerViewAmalgamFetched();

  onCloseBanner = () => {
    this.setState({ showBanner: false });
    onBannerClose();
    EventBus.notify(EventBus.TYPE.NAVBAR_HEIGHT_CHANGED);
  };

  shouldShowBackForSingleCatalogue = () => {
    const { groupRoutePath, resellerRoutePath } = this.state;
    const currentRoutePath = getCurrentUrl();
    return (
      !!groupRoutePath ||
      !!resellerRoutePath ||
      (this.homeToHomePageNavigation && this.entryUrl && this.entryUrl !== currentRoutePath)
    );
  };

  render () {
    const {
      groupAmalgamFetched,
      globalReviewAmalgamFetched,
      amalgamFetched,
      lazyComponentFetched,
      galleryLazyComponentFetched,
      imageLazyComponentFetched,
      resellSingleLazyComponentFetched,
      groupLazyComponentFetched,
      globalReviewLazyComponentFetched,
      resellerViewLazyComponentFetched,
      companyDetailLazyComponentFetched,
      customerOrdersLazyComponentFetched,
      companyDetailAmalgamFetched,
      customerOrdersAmalgamFetched,
      prevRoutePath,
      prevRoute,
      currentRoute,
      productId,
      showBanner
    } = this.state;

    const primaryColor =
      ((getCatalogueTheme() || {}).addToCartButton || {}).backgroundColor || '#249f64';

    return (
      <div className="app">
        {showBanner && currentRoute === ROUTE_NAME.HOME && (
          <FreeCatalogueBanner onClose={this.onCloseBanner} />
        )}
        <SpecialOfferModal />

        <NavBar
          amalgamFetched={amalgamFetched}
          currentRoute={currentRoute}
          prevRoute={prevRoute}
          productId={productId}
          goBack={this.goBack}
          showBackForSingleCatalogue={this.shouldShowBackForSingleCatalogue()}
        />

        <Router onChange={this.onRouteChange}>
          <AsyncRoute
            routeType={CHUNK_VIEW.SINGLE_CATALOGUE}
            name={ROUTE_NAME.HOME}
            path="/s/:companySlug/:catalogueSlug/:randomSlug"
            amalgamFetched={amalgamFetched}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.GALLERY_PAGE}
            name={ROUTE_NAME.GALLERY}
            path="/s/gallery/:companySlug/:catalogueSlug/:randomSlug/product/:productId"
            goBack={this.goBack}
            prevRoutePath={prevRoutePath}
            amalgamFetched={amalgamFetched}
            isAmalgamFetched={this.isAmalgamFetched}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.GALLERY_PAGE}
            name={ROUTE_NAME.GALLERY}
            path="/s/gallery/:companySlug/product/:productId"
            goBack={this.goBack}
            prevRoutePath={prevRoutePath}
            amalgamFetched={amalgamFetched}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.IMAGE_PAGE}
            name={ROUTE_NAME.IMAGE_VIEW}
            path="/s/gallery/:companySlug/:catalogueSlug/:randomSlug/product/:productId/image/:imageId"
            goBack={this.goBack}
            amalgamFetched={this.isAmalgamFetched()}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.IMAGE_PAGE}
            name={ROUTE_NAME.IMAGE_VIEW}
            path="/s/gallery/:companySlug/product/:productId/image/:imageId"
            goBack={this.goBack}
            amalgamFetched={this.isAmalgamFetched()}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.CUSTOMER_ORDERS}
            name={ROUTE_NAME.CUSTOMER_ORDERS}
            path={PATH.CUSTOMER_ORDERS}
            currentRoute={currentRoute}
            amalgamFetched={customerOrdersAmalgamFetched}
            goBack={this.goBack}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.CUSTOMER_ORDERS}
            name={ROUTE_NAME.CUSTOMER_ORDERS_DETAILS}
            path={PATH.CUSTOMER_ORDER_DETAILS}
            currentRoute={currentRoute}
            amalgamFetched={customerOrdersAmalgamFetched}
            goBack={this.goBack}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.COMPANY_DETAIL}
            name={ROUTE_NAME.COMPANY_DETAIL}
            path="/company/:companyDetailSlug/:companyId"
            goBack={this.goBack}
            prevRoutePath={prevRoutePath}
            amalgamFetched={companyDetailAmalgamFetched}
          />

          {/* @Deprecated: will be removed in future releases */}
          <AsyncRoute
            routeType={CHUNK_VIEW.GLOBAL_REVIEW}
            name={ROUTE_NAME.GLOBAL_REVIEW}
            path="/s/review/:companyId"
            currentRoute={currentRoute}
            goBack={this.goBack}
            prevRoutePath={prevRoutePath}
            amalgamFetched={globalReviewAmalgamFetched}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.GLOBAL_REVIEW}
            name={ROUTE_NAME.GLOBAL_REVIEW}
            path="/s/cart/:orderId"
            currentRoute={currentRoute}
            goBack={this.goBack}
            prevRoutePath={prevRoutePath}
            amalgamFetched={globalReviewAmalgamFetched}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.RESELL_SINGLE_CATALOGUE}
            name={ROUTE_NAME.RESELL}
            path="/s/resell/:companySlug/:catalogueSlug/:randomSlug"
            goBack={this.goBack}
            amalgamFetched={this.isAmalgamFetched()}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.GROUP_CATALOGUE}
            name={ROUTE_NAME.GROUP}
            path="/w/:companySlug/:randomSlug"
            groupAmalgamFetched={groupAmalgamFetched}
          />

          <AsyncRoute
            routeType={isCustomPage() ? CHUNK_VIEW.CUSTOM_PAGE : CHUNK_VIEW.GROUP_CATALOGUE}
            name={isCustomPage() ? ROUTE_NAME.CUSTOM_PAGE : ROUTE_NAME.GROUP}
            path="/"
            groupAmalgamFetched={groupAmalgamFetched}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.CUSTOM_PAGE}
            name={ROUTE_NAME.CUSTOM_PAGE}
            path="/:customPageSlug"
            goBack={this.goBack}
            groupAmalgamFetched={groupAmalgamFetched}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.RESELLER}
            name={ROUTE_NAME.RESELLER_VIEW}
            path="/r/:companySlug/:randomSlug"
            resellerViewAmalgamFetched={this.isResellerViewAmalgamFetched()}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.RESELLER}
            name={ROUTE_NAME.RESELLER_ORDER_DETAILS}
            path="/r/:companySlug/:randomSlug/order/:orderId"
            resellerViewAmalgamFetched={this.isResellerViewAmalgamFetched()}
            prevRoute={prevRoute}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.RESELLER}
            name={ROUTE_NAME.RESELLER_PROFILE}
            path="/r/:companySlug/:randomSlug/profile"
            resellerViewAmalgamFetched={this.isResellerViewAmalgamFetched()}
            prevRoute={prevRoute}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.RESELLER}
            name={ROUTE_NAME.RESELLER_CATALOGUE_GALLERY}
            path="/t/gallery/:companySlug/product/:productId"
            amalgamFetched={amalgamFetched}
            goBack={this.goBack}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.RESELLER}
            name={ROUTE_NAME.RESELLER_CATALOGUE_HOME}
            path="/t/:companySlug/:catalogueSlug/:randomSlug"
            amalgamFetched={this.isAmalgamFetched()}
            prevRoute={prevRoute}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.RESELLER}
            name={ROUTE_NAME.RESELLER_CATALOGUE_GALLERY}
            path="/t/gallery/:companySlug/:catalogueSlug/:randomSlug/product/:productId"
            amalgamFetched={amalgamFetched}
            goBack={this.goBack}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.RESELLER}
            name={ROUTE_NAME.RESELLER_IMAGE_VIEW}
            path="/t/gallery/:companySlug/:catalogueSlug/:randomSlug/product/:productId/image/:imageId"
            goBack={this.goBack}
            amalgamFetched={amalgamFetched}
          />

          <AsyncRoute
            routeType={CHUNK_VIEW.RESELLER}
            name={ROUTE_NAME.RESELLER_IMAGE_VIEW}
            path="/t/gallery/:companySlug/product/:productId/image/:imageId"
            goBack={this.goBack}
            amalgamFetched={amalgamFetched}
          />

          {/*
            common-amalgam will exist hence by pass amalgam check
          */}
          <AsyncRoute
            routeType={CHUNK_VIEW.RESELLER}
            name={ROUTE_NAME.RESELLER_GLOBAL_REVIEW}
            path="/u/review/:companyId"
            prevRoute={prevRoute}
            byPassAmalgam
          />

          {/*
            Page will not be re-loaded and will have either common amalgam or some other amalgam, hence by pass check
          */}
          <AsyncRoute
            routeType={CHUNK_VIEW.RESELLER}
            name={ROUTE_NAME.RESELLER_CUSTOMER_ADD}
            path="/u/review/:companyId/customer-add"
            byPassAmalgam
            prevRoute={prevRoute}
          />
        </Router>

        {((isSingleRoute(currentRoute) ||
          isGalleryRoute(currentRoute) ||
          isImageRoute(currentRoute)) &&
          amalgamFetched) ||
        ((currentRoute === ROUTE_NAME.GROUP || currentRoute === ROUTE_NAME.CUSTOM_PAGE) &&
          location.href.indexOf(SEARCH_TERM) > -1) ||
        ((currentRoute === ROUTE_NAME.GROUP || currentRoute === ROUTE_NAME.CUSTOM_PAGE) &&
          isCustomPage()) ||
        currentRoute === ROUTE_NAME.GLOBAL_REVIEW ? (
            <div>
              <Fragment>
                <RequestIdentityModal />
                <RequestIdentityChat />
              </Fragment>
            </div>
          ) : null}

        {/* Commenting this out, this component's css is already setting display to none, so no use mounting it */}
        {/* {isSingleRoute(currentRoute) && amalgamFetched && (
          <ChatNowPopover
            fromPosition={currentRoute === ROUTE_NAME.GALLERY ? 'BOTTOM-LEFT' : 'TOP-RIGHT'}
          />
        )} */}

        <AddressPicker />
        <DeleteAccountConfirmationModal />

        {(isGroupRoute(currentRoute) && groupLazyComponentFetched) ||
        (isCompanyDetailRoute(currentRoute) && companyDetailLazyComponentFetched) ||
        (isCustomerOrdersRoute(currentRoute) && customerOrdersLazyComponentFetched) ||
        (isSingleRoute(currentRoute) && lazyComponentFetched) ||
        (isResellSingleRoute(currentRoute) && resellSingleLazyComponentFetched) ||
        (isGalleryRoute(currentRoute) && galleryLazyComponentFetched) ||
        (isImageRoute(currentRoute) && imageLazyComponentFetched) ||
        (isResellerViewRoute(currentRoute) && resellerViewLazyComponentFetched) ||
        (isReviewRoute(currentRoute) && globalReviewLazyComponentFetched) ? null : (
            <div className="component-loader-container">
              <div
                className="loader"
                style={{
                  border: `solid 5px ${hexToRgba(primaryColor, 0.2)}`,
                  borderLeft: `solid 5px ${primaryColor}`
                }}
              />
            </div>
          )}

        <OrderAlreadyConfirmed />
      </div>
    );
  }
}

export default App;
